import React from 'react'

import { Button } from '@inno-ui/button'
import {
  ArrowRightRectangleLineIcon,
  IconSizes,
  ScreenLineIcon
} from '@inno-ui/icons'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { GetRefreshTokensResponse } from 'shared/api/auth/requests/deviceManagement/getRefreshTokens'

import styles from './LinkedDevices.module.scss'

interface DeviceItemProps {
  device: GetRefreshTokensResponse['data'][0]
  isCurrent: boolean
  onDelete?: (id: number) => void
  isDeleting: boolean
}

export const DeviceItem: React.FC<DeviceItemProps> = ({
  device,
  isCurrent,
  onDelete,
  isDeleting
}) => {
  const { t } = useTranslation('auth', {
    keyPrefix: 'my_profile_page'
  })

  return (
    <div className={styles.item}>
      <div className={styles.leftSection}>
        <ScreenLineIcon size={IconSizes.Size20} />
        <div className={styles.userAgent}>
          <span>{device.device}</span>
          <span>{device.location}</span>
        </div>
      </div>
      <div className={styles.rightSection}>
        <div className={styles.lastActivity}>
          {`${t('last_activity')} ${dayjs(
            device.last_used || device.updated_at
          ).format('DD.MM.YYYY HH:mm')}`}
        </div>
        {!isCurrent && onDelete && (
          <Button
            icon={ArrowRightRectangleLineIcon}
            onClick={() => onDelete(device.id)}
            disabled={isDeleting}
          />
        )}
      </div>
    </div>
  )
}
